export const headers = [
  {
    text: 'Source',
    value: 'lead_source',
    class: 'qualify-leads-table-header',
    sortable: true,
  },
  {
    text: 'Contact',
    value: 'contact_name',
    class: 'qualify-leads-table-header',
    sortable: false,
  },
  {
    text: 'Status',
    value: 'status',
    class: 'qualify-leads-table-header',
    sortable: true,
  },
  {
    text: 'Events',
    value: 'events',
    class: 'qualify-leads-table-header',
    sortable: false,
  },
  {
    text: 'Date Created',
    value: 'created_at',
    class: 'qualify-leads-table-header',
    sortable: true,
  },
  {
    text: 'Last event',
    value: 'last_event',
    class: 'qualify-leads-table-header',
    sortable: false,
  },
];

export const qualifyTypes = [
  {
    id: 1,
    text: 'All',
    types: [],
    allWebTypes: true,
  },
  {
    id: 2,
    text: 'Qualifying',
    types: [],
  },
  {
    id: 3,
    text: 'Follow Up Now',
    types: [],
  },
  {
    id: 4,
    text: 'Follow Up Later',
    types: [],
  },
  {
    id: 5,
    text: 'Not Interested',
    types: [],
  },
  {
    id: 6,
    text: 'Unresponsive',
    types: [],
  },
  {
    id: 7,
    text: 'Just Curious',
    types: [],
  },
];
